import * as React from 'react';
import { Hero } from '../../../components/ReferrerHero';
import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { ReferralsListContainer } from '../ReferralsList';
import { selectReferralsList } from '../../../selectors';
import { useGetReferralLink } from './hooks/useGetReferralLink';
import { useToggleStickyScrollBtn } from '../../../hooks/useToggleStickyScrollBtn';

export const HeroContainer: React.FC = () => {
  const shareBtnRef = React.useRef<HTMLButtonElement>(null);
  const stickyRef = React.useRef<HTMLDivElement>(null);

  useToggleStickyScrollBtn(stickyRef);
  const { handleCopyLinkClick, handleShareLinkClick } = useGetReferralLink(shareBtnRef);

  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const referrals = useSelector(selectReferralsList);
  const hasReferral = !!referrals.length;

  return (
    <Hero
      hasReferrals={hasReferral}
      isDesktop={isDesktop}
      onCopyLinkClick={handleCopyLinkClick}
      onShareLinkClick={handleShareLinkClick}
      shareBtnRef={shareBtnRef}
      stickyRef={stickyRef}
    >
      <ReferralsListContainer />
    </Hero>
  );
};
